module.exports = __webpack_public_path__ + "img/pm.6853a3c3.svg";